const config = {
  apiUrl: 'https://dedline-api.netlify.app/states.json',
};

export default config;